import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HeroSection } from "@/components/HeroSection";
import { ServicesSection } from "@/components/ServicesSection";
import { HowItWorksSection } from "@/components/HowItWorksSection";
import { ProgramsSection } from "@/components/ProgramsSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { FAQSection } from "@/components/FAQSection";
import { ContactSection } from "@/components/ContactSection";
import { ServiceDetailPage } from "@/components/ServiceDetailPage";
import { InstitutionDetailPage } from "@/components/InstitutionDetailPage";
import { ProgramsPage } from "@/components/ProgramsPage";
import { ReviewsPage } from "@/components/ReviewsPage";
import { BlogIndexPage } from "@/components/BlogIndexPage";
import { BlogPostPage } from "@/components/BlogPostPage";
import { SEO } from "@/components/SEO";
import { buildFAQSchema } from "@/lib/seo-schemas";
import { faqData } from "@/data/mock";

const Home = () => {
  return (
    <>
      <SEO
        description="Elevated Education is a Canadian education consulting agency helping students apply to BC career colleges. Expert admissions, student aid, and scholarship guidance — book a free consultation."
        path="/"
        schema={buildFAQSchema(faqData)}
      />
      <HeroSection />
      <ServicesSection />
      <HowItWorksSection />
      <ProgramsSection />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
            <Route path="/institutions/:institutionId" element={<InstitutionDetailPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/blog" element={<BlogIndexPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
